// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const OffsetModeViewEnum = 
{ 
    Ticks: 0, 
    TicksFractionalForForex: 1, 
    Points: 2 
};
Object.freeze(OffsetModeViewEnum);